import type { RootState } from "@/app/store";
import { ProdutoAutorizado } from "@/contexts/laboratorio/produtoAutorizado/model/ProdutoAutorizado";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ProdutoAutorizadoState {
  items: ProdutoAutorizado[];
  synced: boolean;
}

const initialState: ProdutoAutorizadoState = {
  items: [],
  synced: false,
};

const produtoAutorizadoSlice = createSlice({
  name: "PRODUTO_AUTORIZADO",
  initialState,
  reducers: {
    sync: {
      reducer: (
        state,
        action: PayloadAction<{ items: ProdutoAutorizado[] }>
      ) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: ProdutoAutorizado[]) => ({
        payload: { items },
      }),
    },
  },
});

export const produtoAutorizadoAction = produtoAutorizadoSlice.actions;

export default produtoAutorizadoSlice.reducer;

export const getProdutoAutorizadoSynced = (state: RootState) =>
  state.produtoAutorizado.items;
